var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 0.666687C3.94996 0.666687 0.666626 3.95002 0.666626 8.00002C0.666626 12.05 3.94996 15.3334 7.99996 15.3334C12.05 15.3334 15.3333 12.05 15.3333 8.00002C15.3333 3.95002 12.05 0.666687 7.99996 0.666687ZM11.1786 6.76002C11.2372 6.69312 11.2817 6.61518 11.3097 6.5308C11.3376 6.44642 11.3485 6.3573 11.3415 6.26868C11.3345 6.18006 11.3099 6.09373 11.269 6.01477C11.2282 5.93581 11.1719 5.86582 11.1037 5.80891C11.0354 5.75201 10.9564 5.70933 10.8714 5.6834C10.7863 5.65746 10.697 5.6488 10.6085 5.65791C10.5201 5.66702 10.4344 5.69372 10.3565 5.73644C10.2785 5.77917 10.2099 5.83705 10.1546 5.90669L7.28796 9.34602L5.80463 7.86202C5.67889 7.74058 5.51049 7.67339 5.33569 7.6749C5.16089 7.67642 4.99369 7.74654 4.87008 7.87014C4.74647 7.99375 4.67636 8.16095 4.67484 8.33575C4.67332 8.51055 4.74052 8.67895 4.86196 8.80469L6.86196 10.8047C6.92746 10.8702 7.00589 10.9213 7.09224 10.9547C7.17858 10.9882 7.27096 11.0033 7.36347 10.9991C7.45599 10.9949 7.54661 10.9715 7.62957 10.9303C7.71252 10.8892 7.78599 10.8312 7.84529 10.76L11.1786 6.76002Z",
    fill: "#11A97D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.5ad5484f1520c1f532cc6046ff891a13.svg";
export { ForwardRef as ReactComponent };